import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vipio.webp';
import screenshot_target from '../../../images/letterfunnel/reneschoenmakers.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="René Schoenmakers"
      firstname="René"
      companyname="Vipio"
      competition="BijzondereOvernachtingen en Campspace"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/reneschoenmakers.js